<template>
    <div class="down-box">
      <div class="box-item" @click="downloadApp(DownloadUrl1)">
        <img :src="Icon1" alt="">
        <div class="tips">
          <div class="tips-text">{{ tipsText1 }}</div>
          <div class="tips-btn">立即下载</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="box-item" @click="downloadApp(DownloadUrl2)">
        <img :src="Icon2" alt="">
        <div class="tips">
          <div class="tips-text">{{ tipsText2 }}</div>
          <div class="tips-btn">立即下载</div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  const Icon1 = 'https://p4.ssl.qhimg.com/t110b9a9301ff94a8226838ee3b.png'
  const Icon2 = 'https://p1.ssl.qhimg.com/t110b9a9301c796a85efde304ce.png'
  const tipsText1 = '使用360AI浏览器,智阅大会精彩内容'
  const tipsText2 = '了解ISC.AI2024更多 下载360AI搜索'
  const DownloadUrl1 = 'https://mse.360.cn/ai?channel=360isc_browser'
  const DownloadUrl2 = 'https://www.sou.com/market?src=360isc_aisou'

  const downloadApp = (url) => {
    window.open(url)
  }
  </script>
  
  <style lang="scss" scoped>
  .down-box {
    position: fixed;
    width: 100%;
    height: 68px;
    left: 0;
    // gap: 9px;
    // right: 16px;
    bottom: 0px;
    display: flex;
    align-items: center;
    background: #ffffff;
    z-index: 99;
    .box-item{
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 38px;
        height: 38px;
      }
      .tips{
        display: flex;
        flex-direction: column;
        .tips-text {
            margin: 0 0px 6px 8px;
            font-size: 0.5rem;
        }
        .tips-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 8rem;
            height: 24px;
            border-radius: 24px;	
            // background: linear-gradient(90deg, #C344EC 0%, #5583FA 100%);
            background: #000;
            color: #FFFFFF;
            font-size: 12px;
            margin-left: 8px;
        }
      }
    }
    .line {
      width: 1px;
      height: 36px;
      background: #000;
    }
  }
  </style>
  